import React from 'react';

import { PRODUCT_BLOCK_TYPES, useProductBlock } from '../helpers/useProductBlock';
import { AlgoliaQuerySliderView } from './algolia-query';
import { ProductIDsSliderView } from './product-ids';
import { SectionWithProductSliderContent } from './types';

/**
 * V2 `section_with_product_slider` (SERVER PATH). The two `slider_type`s keep their own layouts
 * (background, paddings, breakpoints, heading) but get their products from one place (useProductBlock).
 *
 * The hits were preloaded server-side, so there is deliberately no client (InstantSearch) fallback. One
 * existed once and could do nothing useful: the server skips the preload ONLY when there is no query to
 * run, so the fallback rendered nothing — but not before mounting an <InstantSearch> <Index>, which
 * searched on default parameters (the whole index, every attribute) as soon as it mounted.
 */
export default function SectionWithProductSlider({ content }: { content: SectionWithProductSliderContent }) {
  const { products, tileLayout } = useProductBlock('slider', content?.slider_type, content);

  if (!PRODUCT_BLOCK_TYPES.includes(content?.slider_type)) {
    console.error(`SectionWithProductSlider: unknown slider_type "${content?.slider_type}"`);
    return null;
  }

  const View = content.slider_type === 'Product IDs' ? ProductIDsSliderView : AlgoliaQuerySliderView;
  return <View content={content} products={products} tileLayout={tileLayout} />;
}
